import {create} from "zustand"

interface SelectedThoughtPiecesState {
  id: string
  setId: (value: string) => void
  clearId: () => void
  name: string
  setName: (value: string) => void
  type: string
  setType: (value: string) => void
}

const useSelectedThoughtPiecesStore = create<SelectedThoughtPiecesState>(
  (set) => ({
    id: "",
    setId: (value: string) => set({id: value}),
    clearId: () => set({id: ""}),
    name: "",
    setName: (value: string) => set({name: value}),
    type: "",
    setType: (value: string) => set({type: value}),
  }),
)

export default useSelectedThoughtPiecesStore
